import React from "react";
import {
  REFUND_STATUS,
  REFUND_STATUS_CODE,
  REFUND_STATUS_LABEL,
  RefundRequest,
  RefundStatus,
} from "types/refund";
import Button from "components/button/Button";
import formatDate from "utils/DateUtil";
import "./refund-item.css";
import CardNumber from "components/card-number/CardNumber";

interface Props {
  request: RefundRequest;
  /** Only for a row with no settlementTokenSymbol of its own. */
  fallbackTokenSymbol: string;
  onSettle: (requestId: string, merchantId: string, cardNumber: string) => void;
  onReject: (requestId: string, merchantId: string, cardNumber: string) => void;
  isProcessing: boolean;
}
const STATUS_BADGE: Record<RefundStatus, string> = {
  0: `● ${REFUND_STATUS_LABEL.PENDING}`,
  1: `✓ ${REFUND_STATUS_LABEL.APPROVED}`,
  2: `✕ ${REFUND_STATUS_LABEL.REJECTED}`,
};

function RefundItem({
  request,
  fallbackTokenSymbol,
  onSettle,
  onReject,
  isProcessing,
}: Props) {
  const {
    id,
    merchantId,
    cardNumber,
    amount,
    status,
    createdAt,
    settlementTokenSymbol,
  } = request;
  const statusClass = REFUND_STATUS[status].toLowerCase();

  return (
    <div className="rf-item">
      <div className="rf-item__row">
        <div className="rf-item__info">
          <span className="rf-item__card">
            <CardNumber value={cardNumber} />
          </span>
          <span className="rf-item__date">
            {formatDate(new Date(createdAt))}
          </span>
        </div>
        <span className="rf-item__amount">
          {amount.toFixed(2)} {settlementTokenSymbol ?? fallbackTokenSymbol}
        </span>
        {status === REFUND_STATUS_CODE.PENDING ? (
          <div className="rf-item__actions">
            <Button
              variant="warn"
              size="sm"
              disabled={isProcessing}
              onClick={() => onSettle(id, merchantId, cardNumber)}
            >
              Settle
            </Button>
            <Button
              variant="ghost"
              size="sm"
              disabled={isProcessing}
              onClick={() => onReject(id, merchantId, cardNumber)}
            >
              Reject
            </Button>
          </div>
        ) : (
          <span className={`rf-item__badge rf-item__badge--${statusClass}`}>
            {STATUS_BADGE[status]}
          </span>
        )}
      </div>
    </div>
  );
}

export default RefundItem;
